import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator/index';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles, List, ListItem, ListItemIcon, ListItemText, Divider, Grid } from '@material-ui/core';
import { RemoveCircle, ChatBubbleOutline, CheckCircle, BorderColor } from '@material-ui/icons';
import { Map } from 'immutable';

class ListNotesGit extends Component {
    static propTypes = {
        notes: PropTypes.array
    };

    static defaultProps = {
        notes: []
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    renderNotes() {
        const { notes } = this.props;

        let DynaIcon = ChatBubbleOutline;
        let res = [];

        notes.map(note => {
            let body = note.body;
            let arrayBody = [];
            let array = note.body.split(' ');
            if (array[0] === 'changed') {
                body = 'changeDesc';
                if (array[1] === 'title') {
                    body = 'changedTitle';
                    let bodySplit = note.body.split('**');
                    let regexMoins = /(?<={-)(.*\n?)(?=-})/g;
                    let regexPlus = /(?<={\+)(.*\n?)(?=\+})/g;

                    for (let el of bodySplit) {
                        if (el.match(regexPlus)) {
                            let stringMatched = el.match(regexPlus);
                            let newString = el.split(regexPlus);

                            for (let aString of newString) {
                                if (stringMatched[0] === aString)
                                    arrayBody.push(
                                        <span key={aString} style={{ backgroundColor: '#C7F0D2' }}>
                                            {aString}
                                        </span>
                                    );
                                else arrayBody.push(aString.replace(/\*|{-|-}|{\+|\+}/g, ''));
                            }
                        } else if (el.match(regexMoins)) {
                            let stringMatched = el.match(regexMoins);
                            let newString = el.split(regexMoins);

                            for (let aString of newString) {
                                if (stringMatched[0] === aString)
                                    arrayBody.push(
                                        <span key={aString} style={{ backgroundColor: '#FAC5CD' }}>
                                            {aString}
                                        </span>
                                    );
                                else arrayBody.push(aString.replace(/\*|{-|-}|{\+|\+}/g, ''));
                            }
                        } else arrayBody.push(el);
                    }

                    arrayBody[0] = Translator.translate('ticketsgit.notes.changeTitle');
                    const index = arrayBody.indexOf(' to ');
                    arrayBody.splice(index, 1, Translator.translate('ticketsgit.notes.to'));
                } else arrayBody = note.body;
            } else arrayBody = note.body;

            switch (body) {
                case 'reopened':
                    DynaIcon = RemoveCircle;
                    arrayBody = Translator.translate('ticketsgit.notes.reopen');
                    break;
                case 'closed':
                    DynaIcon = CheckCircle;
                    arrayBody = Translator.translate('ticketsgit.notes.closed');
                    break;
                case 'changeDesc':
                    DynaIcon = BorderColor;
                    arrayBody = Translator.translate('ticketsgit.notes.changeDesc');
                    break;
                case 'changedTitle':
                    DynaIcon = BorderColor;
                    break;
                default:
                    DynaIcon = ChatBubbleOutline;
            }

            res.push(
                <div key={note.id}>
                    <ListItem key={note.id}>
                        <ListItemIcon>
                            <DynaIcon />
                        </ListItemIcon>
                        <ListItemText primary={arrayBody} secondary={`${note.author} - ${note.created_at}`} />
                    </ListItem>
                    <Divider />
                </div>
            );
        });
        return res;
    }

    render() {
        return <List>{this.renderNotes()}</List>;
    }
}

export default ListNotesGit;



// WEBPACK FOOTER //
// ./data/components/ListNotesGit.js